import { UserSchema } from "@tsTypes/next-auth";

export function getSplitName(name: UserSchema["name"]) {
  const [, firstName, lastName] = name.match(/([^\s]+)\s(.*)/) ?? [];
  return { firstName: capFirst(firstName), lastName: capFirst(lastName) };
}
export function getInitials(name: UserSchema["name"]) {
  const splitName = name.split(" ");
  return splitName[0].at(0)! + splitName[splitName.length - 1].at(0);
}
export function capFirst(lowerCaseString: string) {
  return lowerCaseString[0].toUpperCase() + lowerCaseString.slice(1);
}

export function getSubjectColorIndex(subjectName: string) {
  // remove IB from stripe product names we pass in here in one case
  // the split removes all 2025 or (old) suffixes and just gets the main subject
  return subjectName.replace("IB ", "").split(" ")[0].toLowerCase();
}

export function capAll(lowerCaseString: string) {
  return lowerCaseString
    .split(" ")
    .map((word) => {
      if (word.toLowerCase() === "ia") {
        return "IA";
      } else if (word.toLowerCase() === "aa") {
        return "AA";
      } else if (word.toLowerCase() === "ai") {return "AI"} else {
        return capFirst(word);
      }
    })
    .join(" ");
}

export function stripParagraphTag(string: string) {
  const match = string.match(/^<p[^>]*>([\s\S]*)<\/p>$/);
  if (match) {
    return capFirst(match[1]);
  }
  return capFirst(string);
}

export type SelectedAccountType = "Basic" | "Trial" | "Member";
